// @ constants
const actionTypes = require('../insuranceConstants/actionTypes');

const insuranceChosenMortgageRequest = data => ({
    type: actionTypes.INSURANCE_CHOSEN_MORTGAGE_REQUEST,
    data: data
});

const setInsuranceChosenMortgage = (data) => (dispatch) => {
    dispatch(insuranceChosenMortgageRequest(data));
};

module.exports = {
    setInsuranceChosenMortgage
};
